import { createAction } from 'redux-actions';

import Job from '../../api/job-api-client';

const loadNotificationTypesStart = createAction('LOAD_NOTIFICATION_TYPES_STARTING');
const loadNotificationTypesSuccess = createAction('LOAD_NOTIFICATION_TYPES_SUCCESS');
const loadNotificationTypesFailure = createAction('LOAD_NOTIFICATION_TYPES_FAILURE');

export const loadNotificationTypes = () => (dispatch: Function, getState: Function) => {
  const state = getState();
  if (state.jobs.notificationTypes || state.jobs.notificationTypesLoading) {
    return null;
  }
  dispatch(loadNotificationTypesStart());
  return Job.loadNotificationTypes()
    .then((response) => {
      if (!response.ok) {
        dispatch(loadNotificationTypesFailure(response));
        return null;
      }
      return response.json();
    })
    .then((notificationTypes) => {
      dispatch(
        loadNotificationTypesSuccess({
          notificationTypes,
        }),
      );
    });
};
